module.exports = __webpack_public_path__ + "static/media/dashboardPage.f491382f.png";